export default {
  title: {
    companyManagement: 'Company Management',
    roleManagement: 'Role Management',
    companyAdd: 'Add Company',
    companyEdit: 'Edit Company'
  },
  menu: 'Company Management',
  label: {
    name: 'English Name',
    cnName: 'Chinese Name',
    company: 'Company',
    country: 'Country / Region',
    province: 'Province / State',
    city: 'City / Town',
    companyEnglishName: 'Company English Name',
    companyChineseName: 'Company Chinese Name',
    parentCompany: 'Parent Company',
    option: 'Operation',
    companyName: 'Company Name',
    addCompany: 'Add Company',
    editCompany: 'Edit Company'
  },
  placeholder: {
    country: 'Please select Country / Region',
    province: 'Please select Province / State',
    city: 'Please select City / Town',
    companyEnglishName: 'Please input company English name',
    companyChineseName: 'Please input company Chinese name',
    parentCompany: 'Please select parent company'
  },
  btn: {
    addCompany: 'Add Company'
  },
  message: {
    parentCompanyError: 'You can not set parent to its child company',
    optionSuccess: 'Option Success',
    optionField: 'Option Field',
    deleteConfirm: 'Are you sure to delete this company {companyName} ?',
    companyRequired: 'This field is required'
  }
}
